import {
    REGISTRATION_MODE,
    RegistrationState,
    TAB_TYPE,
} from '@/types/pages/storeManagement/registration/registrationTypes';

export const defaultState: RegistrationState = {
    labelOptions: [
        {
            key: TAB_TYPE.AP,
            label: TAB_TYPE.AP,
            disable: true,
            tooltip: '', // Tag Registration is in progress; cannot switch to the AP tab.
        },
        {
            key: TAB_TYPE.RT,
            label: TAB_TYPE.RT,
            disable: true,
            tooltip: '',
        },
        {
            key: TAB_TYPE.TAG,
            label: TAB_TYPE.TAG,
            disable: true,
            tooltip: '',
        },
    ],
    currentTab: TAB_TYPE.NONE,
    registrationMode: REGISTRATION_MODE.NORMAL_MODE,
    editAPInfo: null,
    storeDeviceTotal: 0,
    infraDevice: [],
    searchMac: '',
    toggleTagProgress: false,
    apLockInfo: { isLock: false, mac: '' },
    tagState: {
        isOnProgress: false,
        status: { confirmed: 0, total: 0 },
    },
    tagStatus: { confirmed: 0, total: 0 },
    loadingState: {
        storeStateLoading: false,
        deviceTableLoading: false,
    },
    dialogState: {
        isApOpen: false,
        isStoreStateOpen: false,
        isTagOpen: false,
        isApLockOpen: false,
        isDeleteOpen: false,
    },
    deviceInfoState: {
        status: 'init',
        isLoading: false,
        sortModel: { field: null, sort: null },
        paginationModel: { page: 0, pageSize: 5 },
        infraDeviceInfo: [],
        selectedInfraDevices: [],
        rowCount: 0,
        doingTask: false,
    },
};
